import React, { useState } from "react";
import PropTypes from "prop-types";

import useFeatures from "components/FeatureFlag/useFeatures";

import { useOnboardingUseCaseItemProps } from "./hooks";
import EmbedVideo from "../EmbedVideo";
import OnboardingWidget from "../OnboardingWidget";
import { SkipUseCasesWidgetModal } from "./components";

export function UseCasesWidget({
  title,
  welcomeVideo,
  welcomeMessage,
  useCases,
}) {
  const [isSkipModalOpen, setIsSkipModalOpen] = useState(false);
  const toOnboardingItems = useOnboardingUseCaseItemProps(useCases);

  return (
    <React.Fragment>
      <OnboardingWidget
        title={title}
        welcomeMessage={welcomeMessage}
        items={useCases.map(toOnboardingItems)}
        videoSection={
          welcomeVideo?.src && (
            <EmbedVideo
              src={welcomeVideo.src}
              title={welcomeVideo.title || "Welcome to Hubly Video"}
              width={welcomeVideo.width}
              height={welcomeVideo.height}
            />
          )
        }
        videoPosition={welcomeVideo?.position}
      >
        <button
          type="button"
          onClick={() => {
            return setIsSkipModalOpen(true);
          }}
          style={{
            color: "#4183C4",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "0",
            fontFamily: "Helvetica Neue",
            fontWeight: "bold",
          }}
        >
          Skip, I want to explore Hubly on my own
        </button>
      </OnboardingWidget>

      {isSkipModalOpen && (
        <SkipUseCasesWidgetModal
          onClose={() => {
            return setIsSkipModalOpen(false);
          }}
        />
      )}
    </React.Fragment>
  );
}

UseCasesWidget.propTypes = {
  title: PropTypes.string.isRequired,
  welcomeVideo: PropTypes.shape({
    src: PropTypes.string.isRequired,
    title: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    position: PropTypes.oneOf(["top", "left", "bottom", "right"]),
  }),
  welcomeMessage: PropTypes.string.isRequired,
  useCases: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      icon: PropTypes.string,
      templateName: PropTypes.string,
    })
  ).isRequired,
};

UseCasesWidget.defaultProps = { welcomeVideo: null };

function Connector() {
  const data = useFeatures("onboarding-use-cases-widget");

  if (!data?.useCases) return null;

  return <UseCasesWidget {...data} />;
}

export default Connector;
